import { Spacer } from '@adserve/adserve-react-components';
import React, { useState, useEffect } from 'react';
import AdvancedSettings from './AdvancedSettings';
import CopyTypes from './CopyTypes';
import CopyTypeExclusions from './CopyTypeExclusions';
import DayPartWeightings from './DayPartWeightings';
import { pageContainerStyle, sectionedPanelStyle } from '../CampaignStyles';
import { GetCampaignSettings } from '../../../services/CampaignsDataService';
import BudgetAllocations from './BudgetAllocations';

const AutomationSettings = ({
    campaign,
    changeMade,
    staticData,
    networks,
    readOnly,
    onSpotTypeDistributionApprovalClick,
    activeRequest = {},
    onRationaleChange
}) => {
    const containerStyle = {
        ...sectionedPanelStyle,
        paddingLeft: 230,
        paddingRight: 87
    };
    const [changeSpotDistribution, setChangeSpotDistribution] = useState(false);
    const [spotTypeDistributionWorkflowId, setSpotTypeDistributionWorkflowId] = useState();

    useEffect(() => {
        GetCampaignSettings()
            .then((data) => {
                setChangeSpotDistribution(data.changeSpotDistribution);
                setSpotTypeDistributionWorkflowId(data.spotTypeDistributionWorkflowId);
            })
            .catch(console.log);
    }, []);

    return (
        <div style={pageContainerStyle} key={'automationsettingspanel'}>

            <div style={{ ...containerStyle, paddingRight: 'none', paddingLeft: '10%' }}>
                <CopyTypes staticData={staticData} campaign={campaign} onChange={changeMade} readOnly={readOnly} />
            </div>

            <Spacer height={16} width={0} />

            <div style={{ ...containerStyle, paddingRight: 'none', paddingLeft: '10%' }}>
                <CopyTypeExclusions
                    campaign={campaign}
                    changeMade={changeMade}
                    staticData={staticData}
                    networks={networks}
                    readOnly={readOnly}
                />
            </div>

            <Spacer height={16} width={0} />

            <div
                style={{
                    ...containerStyle,
                    paddingLeft: '10%',
                    paddingRight: '5%',
                    paddingBottom: 20
                }}
            >
                <DayPartWeightings
                    campaign={campaign}
                    changeMadeParent={changeMade}
                    readOnly={readOnly}
                    campaignShapes={staticData.campaignShapes}
                    onSpotTypeDistributionApprovalClick={onSpotTypeDistributionApprovalClick}
                    activeRequest={activeRequest}
                    onRationaleChange={onRationaleChange}
                    changeSpotDistribution={changeSpotDistribution}
                    spotTypeDistributionWorkflowId={spotTypeDistributionWorkflowId}
                />

            </div>
            <Spacer height={16} width={0} />
            {/* <div
                style={{
                    ...containerStyle,
                    paddingLeft: '10%',
                    paddingRight: '5%',
                    paddingBottom: 20
                }}
            >
                <BudgetAllocations
                    campaign={campaign}
                    changeMadeParent={changeMade}
                    readOnly={readOnly}
                />
            </div>
            <Spacer height={16} width={0} /> */}
        </div>
    );
};

export default AutomationSettings;
